/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react"

import useClickOutside from "../../utils/hooks/use-click-outside"
import useDisableBodyScroll from "../../utils/hooks/use-disable-body-scroll"
import * as styles from "./index.module.scss"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean
  onClose: () => void
  menu?: boolean
}

const Modal: React.FC<Props> = ({
  open,
  onClose,
  className,
  children,
  menu,
  ...otherProps
}) => {
  const contentRef = React.useRef(null)

  useClickOutside(contentRef, onClose)
  useDisableBodyScroll(open)

  if (!open) {
    return null
  }

  return (
    <div {...otherProps} className={`${styles.frame} ${open && styles.open}`}>
      <div className={menu ? styles.menuBackground : styles.background}>
        <div
          className={`${
            menu ? styles.menuContent : styles.content
          } ${className}`}
          ref={contentRef}
        >
          <a
            onClick={onClose}
            onKeyPress={onClose}
            tabIndex={0}
            className={styles.close}
            role="button"
          >
            w
          </a>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal
